<template>
<div>
   <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
         <top-header id="height2"></top-header>
      <main-menu id="height3"></main-menu>
         <div id="reporting" class="container-fluid menu-margin-top" style="padding-left:0px;padding-right:0px">
            <!-- Start the code for this screen here -->
            <div>
               <nav class="navbar navbar-expand-lg bg-info text-white">
                  <span>
                  <b>Automated Quote Tool</b>
                  </span>
               </nav>
               <center>
                  <span :style="msgcolor">{{uploadingMessage}}</span>
               </center>
               <div v-if="saved">
                  <p align="center" class="confirm-message">{{getpurchasedatalist.status.status}}</p>
               </div>
                <div v-if="saved">
         <label class="col-form-label col-form-label-sm" for="marketAdjustmentChoice" style="margin-left : 2%;">Months Available : {{getpurchasedatalist.status.MonthsAvailable}}</label>
         <label class="col-form-label col-form-label-sm" for="marketAdjustmentChoice" style="margin-left : 2%;">Months Required : {{getpurchasedatalist.status.MonthsRequired}}</label>
                  </div>
               <table class="table" v-if="this.getpurchasedatalist.response != null">
                  <thead>
                     <tr style="background-color : #D7DBDD;">
                        <th scope="col">Year</th>
                        <th scope="col">Vehicle Year</th>
                        <th scope="col">Vehicle Make</th>
                        <th scope="col">Vehicle Model</th>
                        <th scope="col">Adjusted Wholesale Value</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr v-if="getpurchasedatalist.response.inception != undefined" >
                        <th scope="row">@ Inception</th>
                        <td >{{getpurchasedatalist.request.year}}</td>
                        <td>{{getpurchasedatalist.request.make}}</td>
                        <td>{{getpurchasedatalist.request.model}}</td>
                        <td >  $ {{getpurchasedatalist.response.inception}}</td>
                     </tr>
                     <tr v-if="getpurchasedatalist.response.month12 != undefined">
                        <th scope="row">@ Month 12</th>
                        <td >{{getpurchasedatalist.request.year}}</td>
                        <td>{{getpurchasedatalist.request.make}}</td>
                        <td>{{getpurchasedatalist.request.model}}</td>
                        <td >  $ {{getpurchasedatalist.response.month12}}</td>
                     </tr>
                     <tr v-if="getpurchasedatalist.response.month24 != undefined">
                        <th scope="row">@ Month 24</th>
                        <td >{{getpurchasedatalist.request.year}}</td>
                        <td>{{getpurchasedatalist.request.make}}</td>
                        <td>{{getpurchasedatalist.request.model}}</td>
                        <td > $ {{getpurchasedatalist.response.month24}}</td>
                     </tr>
                     <tr v-if="getpurchasedatalist.response.month36 != undefined">
                        <th scope="row">@ Month 36</th>
                        <td >{{getpurchasedatalist.request.year}}</td>
                        <td>{{getpurchasedatalist.request.make}}</td>
                        <td>{{getpurchasedatalist.request.model}}</td>
                        <td > $ {{getpurchasedatalist.response.month36}}</td>
                     </tr>
                     <tr v-if="getpurchasedatalist.response.month48 != undefined">
                        <th scope="row">@ Month 48</th>
                        <td >{{getpurchasedatalist.request.year}}</td>
                        <td>{{getpurchasedatalist.request.make}}</td>
                        <td>{{getpurchasedatalist.request.model}}</td>
                        <td > $ {{getpurchasedatalist.response.month48}}</td>
                     </tr>
                     <tr v-if="getpurchasedatalist.response.month60 != undefined">
                        <th scope="row">@ Month 60</th>
                        <td >{{getpurchasedatalist.request.year}}</td>
                        <td>{{getpurchasedatalist.request.make}}</td>
                        <td>{{getpurchasedatalist.request.model}}</td>
                        <td > $ {{getpurchasedatalist.response.month60}}</td>
                     </tr>
                     <tr v-if="getpurchasedatalist.response.month72 != undefined">
                        <th scope="row">@ Month 72</th>
                        <td >{{getpurchasedatalist.request.year}}</td>
                        <td>{{getpurchasedatalist.request.make}}</td>
                        <td>{{getpurchasedatalist.request.model}}</td>
                        <td > $ {{getpurchasedatalist.response.month72}}</td>
                     </tr>
                     <tr v-if="monthN != ''">
                        <th scope="row">@{{Object.keys(getpurchasedatalist.response)[Object.keys(getpurchasedatalist.response).length - 1].replace("m"," M").replace("h","h ")}}</th>
                        <td >{{getpurchasedatalist.request.year}}</td>
                        <td>{{getpurchasedatalist.request.make}}</td>
                        <td>{{getpurchasedatalist.request.model}}</td>
                        <td > $ {{monthN}}</td>
                     </tr>
                  </tbody>
               </table>
               <br>
               <center v-if="this.getpurchasedatalist.response != null">
               <label class="col-form-label col-form-label-sm" for="marketAdjustmentChoice" style="color:red;">{{monthMessage}}</label>
               </center>
               <hr v-if="this.getpurchasedatalist.response != null">
               <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 mb-2 p-2">
               <div class="col-12 col=md-12 d-flex justify-content-lg-end align-items-center">
                     <input type="checkbox" id="marketAdjustmentChoice"  v-model="checked" @click="adjustments">
                     <label class="col-form-label col-form-label-sm" for="marketAdjustmentChoice" style="margin-left : 2%;">Market Adjustment</label>
                  </div>
                  <div class="col-12 col=md-12 d-flex justify-content-lg-end align-items-center">
                     <input id="vin" type="radio" name="vinChecked" value="vin"  v-model="vinChecked" @click="radioDisable = true;clearMessage();">
                     <label class="col-form-label col-form-label-sm" style="margin-left : 2%;">VIN</label>
                  </div>
                  <div
                     class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                     >
                     <input type="text" v-model="collateraldata.vin" @change = "getInfo" class="form-control input-sm" placeholder="Enter VIN" :disabled= !radioDisable>
                  </div>
                  <div class="col-12 col=md-12 d-flex justify-content-lg-end align-items-center">
                     <input id="vechicle" type="radio" name="vinChecked" value="vechicle" v-model="vinChecked" @click="radioDisable = false;clearMessage();" >
                     <label class="col-form-label col-form-label-sm" style="margin-left : 2%;">Vechicle Info</label>
                  </div>

               </div>
       <div class="form-horizontal">
  <div class="control-group form-inline">
    <label for="name" class="control-label col-xs-4">Adjustment Made : </label>
     <label for="name" class="control-label col-xs-4">{{collateraldata.adjustmentMade}}</label>

     <label for="name" class="control-label col-xs-4">Adjustment Value</label>
 <div class="controls col-xs-8 ">
      <input type="text" id="name" v-model="collateraldata.adjustmentValue" placeholder="Enter Adjustment Value" class="form-control input-sm" style="width:120%;margin-right:2%;">
    </div>
  </div>

</div>
<br>

               <!--<div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 mb-2 p-2">
                  <div class="col-12 col=md-12 d-flex justify-content-lg-end align-items-center">
                  <input type="radio" v-model="vechicleInfoChecked" >
                    <label class="col-form-label col-form-label-sm"><b>Vehicle Info</b></label>
                  </div>

                  </div>-->
               <div class="card h-100 border border-5">
                  <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 mb-2 p-2 ">
                     <div class="col-12 col=md-12 d-flex justify-content-lg-end align-items-center">
                        <label class="col-form-label col-form-label-sm required">Year</label>
                     </div>
                     <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                        >
                        <input data-vv-name="year" v-validate="'required'"  class="form-control input-sm"  type="search" list="yearlist" placeholder="Enter Year"    v-model="collateraldata.year" @change="retrievemakelist" data-vv-as="year" >
  <datalist id="yearlist">
   <option  v-for="loan in yearlist" >{{loan.year}}</option>
  </datalist>
                        <div v-if="errors.has('year')" class="alert-danger">{{ errors.first('year') }}</div>
                     </div>
                     <div class="col-12 col=md-12 d-flex justify-content-lg-end align-items-center">
                        <label class="col-form-label col-form-label-sm required" >Make</label>
                     </div>
                     <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                        >
                       <input data-vv-name="make" v-validate="'required'"  class="form-control input-sm"  type="search" list="makelist" placeholder="Enter Make"    v-model.trim="collateraldata.make" @change="retrievemodellist" data-vv-as="make" >
  <datalist id="makelist">
   <option  v-for="loan in makelist" >{{loan.make}}</option>
  </datalist>
                        <div v-if="errors.has('make')" class="alert-danger">{{ errors.first('make') }}</div>
                     </div>
                     <div class="col-12 col=md-12 d-flex justify-content-lg-end align-items-center">
                        <label class="col-form-label col-form-label-sm required" >Model</label>
                     </div>
                     <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                        >
                        <input data-vv-name="model" class="form-control input-sm" v-validate="'required'"  type="search" list="modellist" placeholder="Enter Model"    v-model.trim="collateraldata.model"  @change="retrievestylelist" data-vv-as="model" >
  <datalist id="modellist">
   <option  v-for="loan in modellist" >{{loan.model}}</option>
  </datalist>
                        <div v-if="errors.has('model')" class="alert-danger">{{ errors.first('model') }}</div>
                     </div>
                     <br><br>
                     <div class="col-12 col=md-12 d-flex justify-content-lg-end align-items-center">
                        <label class="col-form-label col-form-label-sm">Trim Style</label>
                     </div>
                     <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                        >
                        <input  type="search" list="stylelist"  class="form-control input-sm" placeholder="Enter Trim"    v-model.trim="collateraldata.trimstyle" >
  <datalist id="stylelist">
   <option  v-for="loan in stylelist" >{{loan.trimStyle}}</option>
  </datalist>
                     </div>
                  </div>
               </div>
               <br>
               <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 mb-2 p-2">
                  <div class="col-12 col=md-12 d-flex justify-content-lg-end align-items-center">
                     <label class="col-form-label col-form-label-sm required">Initial Wholesale Value</label>
                  </div>
                  <div
                     class="col-12 col-md-12 justify-content-end align-items-center mb-lg-0 mb-md-3 mb-sm-3"
                     >
                     <div class="input-group">
                        <div class="input-group-prepend">
                           <span class="form-control input-sm">$</span>
                        </div>
                        <input data-vv-name="Initial Wholesale Value"
                           v-validate="'required'"
                           type="number"
                           class="form-control input-sm"
                           v-model.number="collateraldata.PurchasePrice"
                           data-vv-as="Initial Wholesale Value" placeholder="0" />
                        <div v-if="errors.has('Initial Wholesale Value')" class="alert-danger">{{ errors.first('Initial Wholesale Value') }}</div>
                     </div>
                  </div>
                  <div class="col-12 col=md-12 d-flex justify-content-lg-end align-items-center">
                     <label class="col-form-label col-form-label-sm required">Loan Duration</label>
                  </div>
                  <div
                     class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                     >
                     <input
                        data-vv-name="loanduration"
                        v-validate="'required'"
                        class="form-control input-sm"
                        type="search"
                        list="loandurationlist"
                        placeholder="Enter LoanDuration"
                        v-model="collateraldata.loanduration"
                        data-vv-as="loanduration"
                        />
                     <datalist id="loandurationlist">
                        <option v-for="loan in loandurationlist">{{loan.loanduration}}</option>
                     </datalist>
                     <div
                        v-if="errors.has('loanduration')"
                        class="alert-danger"
                        >{{ errors.first('loanduration') }}</div>
                  </div>
               </div>
               <center class="mb-3">
                  <button type="button" @click="getpurchasedetails" class="btn btn-secondary">Submit</button>
                  &nbsp;
                  <button
                     type="button"
                     @click="resetdata()"
                     class="btn btn-secondary"
                     >Reset</button>
               </center>
            </div>
            <nav class="navbar navbar-expand-lg bg-info text-white">
               <span>
               <b>Upload CSV File</b>
               </span>
            </nav>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
               <div class="col-12 col=md-12 d-flex justify-content-lg-end align-items-center">
                  <label class="col-form-label col-form-label-sm required">Upload Factor Values</label>
               </div>
               <div
                  class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  >
                  <input
                     type="file"
                     @change="onFileSelected"
                     class="form-control input-sm"
                     id="uploadfile"
                     />
                  <span class="alert-danger">{{message}}</span>
               </div>
               <div
                  class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 d-none d-sm-block d-md-none"
                  ></div>
               <div class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <button class="btn btn-secondary" @click="onUpload">Upload</button>

               </div>
               <download-csv
            :name="factorexport"
            :title="factorExport"
            worksheet="Customer Data"
            :data="factorData"

          >
           <button class="btn btn-secondary" @click ="getFactorToExport">Export Factor CSV</button>
          </download-csv>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
               <div class="col-12 col=md-12 d-flex justify-content-lg-end align-items-center">
                  <label class="col-form-label col-form-label-sm required">Market Adjustment</label>
               </div>
               <div
                  class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  >
                  <input
                     type="file"
                     @change="onMarketFileSelected"
                     class="form-control input-sm"
                     id="uploadMarketFile"
                     />
                  <span class="alert-danger">{{adjustMessage}}</span>
               </div>
               <div
                  class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 d-none d-sm-block d-md-none"
                  ></div>
               <div class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <button class="btn btn-secondary" @click="onMarketfileUpload">Upload</button>
               </div>
               <download-csv
            :name="marketexport"
            :title="marketExport"
            worksheet="Customer Data"
            :data="marketData"

          >
           <button class="btn btn-secondary" @click = "getMarketToExport">Export Market CSV</button>
          </download-csv>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
               <div class="col-12 col=md-12 d-flex justify-content-lg-end align-items-center">
                  <label class="col-form-label col-form-label-sm required">Global Adjustment</label>
               </div>
               <div
                  class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  >
                  <input
                     type="file"
                     @change="onGlobalFileSelected"
                     class="form-control input-sm"
                     id="uploadGlobalFile"
                     />
                  <span class="alert-danger">{{adjustMessage}}</span>
               </div>
               <div
                  class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 d-none d-sm-block d-md-none"
                  ></div>
               <div class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <button class="btn btn-secondary" @click="onGlobalfileUpload">Upload</button>
               </div>
               <download-csv
            :name="globalexport"
            :title="globalExport"
            worksheet="Customer Data"
            :data="globalData"
          >
           <button class="btn btn-secondary" @click = "getGlobalToExport" >Export Global CSV</button>
          </download-csv>
            </div>
            <!-- <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
               <div class="col-12 col=md-12 d-flex justify-content-lg-end align-items-center">
                 <label class="col-form-label col-form-label-sm required">Market Adjustment</label>
               </div>
               <div
                 class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
               >
                 <input
                   type="file"
                   @change="onMarketFileSelected"
                   class="form-control input-sm"
                   id="uploadMarketFile"
                 />
                 <span class="alert-danger">{{message}}</span>
               </div>
               <div
                 class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 d-none d-sm-block d-md-none"
               ></div>
               <div class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                 <button class="btn btn-secondary" @click="onMarketfileUpload">Upload</button>
               </div>
               </div>-->
            <div id="myModal" class="modal">
               <!-- Modal content -->
               <div class="loader">
                  <div class="cogs">
                     <div class="cog cog0">
                        <div class="bar"></div>
                        <div class="bar"></div>
                        <div class="bar"></div>
                        <div class="bar"></div>
                     </div>
                  </div>
               </div>
               <div class="loader">
                  <div class="cogs">
                     <div class="cog cog0">
                        <div class="bar"></div>
                        <div class="bar"></div>
                        <div class="bar"></div>
                        <div class="bar"></div>
                     </div>
                  </div>
               </div>
               <div>
                  <p style="margin-left:500px; margin-top:2px">please wait uploading the data....</p>
               </div>
            </div>
         </div>
      </div>
   </div>
   <bottom-footer></bottom-footer>
</div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import collateralprice from '../js/http-collateralprice.js'
import moment from 'moment'

export default {
  components: { MainMenu, TopHeader, BottomFooter },
  data () {
    return {
      msgcolor: {
        color: 'black'
      },
      message: '',
      monthMessage: '',
      adjustMessage: '',
      globalMessage: '',
      year: '',
      make: '',
      model: '',
      trim: '',
      checked: true,
      factorexport: '',
      globalexport: '',
      marketexport: '',
      factorExport: '',
      marketExport: '',
      globalExport: '',
      factorData: [],
      globalData: [],
      marketData: [],
      responsemessage: '',
      vinChecked: 'vin',
      radioDisable: 'true',
      vechicleInfoChecked: '',
      uploadingMessage: '',
      selectedFile: '',
      monthN: '',
      selectedMarketFile: '',
      selectedGlobalFile: '',
      saved: false,
      makelist: [],
      modellist: [],
      yearlist: [],
      stylelist: [],
      loandurationlist: [
        { loanduration: '0' },
        { loanduration: '12' },
        { loanduration: '24' },
        { loanduration: '36' },
        { loanduration: '48' },
        { loanduration: '60' },
        { loanduration: '72' }
      ],
      collateraldata: this.initializedata(),
      getpurchasedatalist: []
    }
  },
  mounted () {
    this.fetchdata()
    this.myFunction()
    this.menuheight()
  },
  methods: {
    adjustments () {
      if (this.checked == false) {
        this.collateraldata.adjustmentMade = 'Market Adjustment'
        this.checked = false
        console.log('VIN NUMBER  : ' + this.collateraldata.marketAdjustmentChoice)
      } else if (this.checked == true) {
        this.collateraldata.adjustmentMade = 'Global Adjustment'
        this.checked = true
      }
    },
    clearMessage () {
      console.log('HELLO')
      this.message = ''
      this.uploadingMessage = ''
      this.errors.clear()
      this.$validator.reset()
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#reporting').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },
    getInfo () {
      console.log('Enter')
      this.uploadingMessage = ''
      collateralprice
        .get('/getVechicleInfo/' + this.collateraldata.vin)
        .then(response => {
          console.log('response.data.year : ' + response.data.year)
          this.collateraldata.year = response.data.year
          this.collateraldata.make = response.data.make
          this.collateraldata.model = response.data.model
          this.collateraldata.trimstyle = response.data.trim
          //  for(var i = 0; i< this.yearlist.length;i++){
          //   if(this.year == this.yearlist[i].year ){
          //   console.log("YEAR LIST : " + this.yearlist[i].year)
          //  this.collateraldata.year =this.yearlist[i].year
          //  this.retrievemakelist();

          // }
          //  }
          setTimeout(() => this.errorMessageDisplay(), 5000)
          console.log('INFO RESPONSE  : ' + JSON.stringify(response.data))
        })
        .catch(e => {
          this.errors.push(e)
        })

      console.log('make list : ' + this.makelist.length)
    },
    errorMessageDisplay () {
      if (this.collateraldata.year == '' || this.collateraldata.make == '' || this.collateraldata.model == '') {
        this.msgcolor.color = 'red'
        this.uploadingMessage = 'Vehicle details are unavailable, please try with vehicle info'
      }
    },

    initializedata () {
      return {
        make: '',
        year: '',
        model: '',
        trimstyle: '',
        loanduration: '72',
        PurchasePrice: '',
        vin: '',
        marketAdjustmentChoice: true,
        adjustmentMade: 'Market Adjustment',
        adjustmentValue: ''
      }
    },

    onFileSelected (event) {
      this.selectedFile = event.target.files[0]
      console.log(event)
    },
    onMarketFileSelected (event) {
      this.selectedMarketFile = event.target.files[0]
      console.log(event)
    },
    onGlobalFileSelected (event) {
      this.selectedGlobalFile = event.target.files[0]
      console.log(event)
    },
    onUpload () {
      this.uploadingMessage = ''
      if (document.getElementById('uploadfile').value != '') {
        this.message = ''
        var modal = document.getElementById('myModal')
        modal.style.display = 'block'
        const fd = new FormData()
        fd.append('file', this.selectedFile, this.selectedFile.name)
        collateralprice
          .post('/uploadPurchasePrice', fd, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          .then(response => {
            modal.style.display = 'none'
            console.log(response)
            document.getElementById('uploadfile').value = null
            this.getGlobalToExport()
            this.getMarketToExport()
            this.getFactorToExport()
            var status = response.data
          })
          .catch(e => {
            console.log('Error in save data: ' + e)
            if (e.message == 'Request failed with status code 417') {
              this.uploadingMessage =
                'Could not upload the file: collateralCSVFile!'
              document.getElementById('uploadfile').value = null
            } else if (e.message == 'Request failed with status code 400') {
              this.uploadingMessage = 'Please upload a csv file!'
              document.getElementById('uploadfile').value = null
            } else {
              this.uploadingMessage = ''
            }
            this.failure = true
            modal.style.display = 'none'
          })
      } else {
        this.message = 'choose a csv file'
        this.uploadingMessage = ''
      }
    },

    onMarketfileUpload () {
      this.uploadingMessage = ''
      if (document.getElementById('uploadMarketFile').value != '') {
        this.adjustMessage = ''
        var modal = document.getElementById('myModal')
        modal.style.display = 'block'
        const fd = new FormData()
        fd.append('adjustmentFile', this.selectedMarketFile, this.selectedMarketFile.name)
        collateralprice
          .post('/marketAdjustment', fd, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          .then(response => {
            modal.style.display = 'none'
            console.log(response)
            document.getElementById('uploadMarketFile').value = null
            this.getGlobalToExport()
            this.getMarketToExport()
            this.getFactorToExport()
            var status = response.data
            this.msgcolor.color = 'green'
            this.uploadingMessage = 'Market Adjustments CSV is Successfully Uploaded'
          })
          .catch(e => {
            console.log('Error in save data: ' + e)
            if (e.message == 'Request failed with status code 417') {
              this.uploadingMessage =
                'Could not upload the file: marketAdjustmentCSVFile!'
              document.getElementById('uploadMarketFile').value = null
            } else if (e.message == 'Request failed with status code 400') {
              this.uploadingMessage = 'Please upload a csv file!'
              document.getElementById('uploadMarketFile').value = null
            } else {
              this.uploadingMessage = ''
            }
            this.failure = true
            modal.style.display = 'none'
          })
      } else {
        this.adjustMessage = 'choose a csv file'
        this.uploadingMessage = ''
      }
    },

    onGlobalfileUpload () {
      this.uploadingMessage = ''
      if (document.getElementById('uploadGlobalFile').value != '') {
        this.globalMessage = ''
        var modal = document.getElementById('myModal')
        modal.style.display = 'block'
        const fd = new FormData()
        fd.append('globalAdjustmentFile', this.selectedGlobalFile, this.selectedGlobalFile.name)
        collateralprice
          .post('/globalAdjustment', fd, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          .then(response => {
            modal.style.display = 'none'
            console.log(response)
            document.getElementById('uploadGlobalFile').value = null
            this.getGlobalToExport()
            this.getMarketToExport()
            this.getFactorToExport()
            var status = response.data
            this.msgcolor.color = 'green'
            this.uploadingMessage = 'Global Adjustments CSV is Successfully Uploaded'
          })
          .catch(e => {
            console.log('Error in save data: ' + e)
            if (e.message == 'Request failed with status code 417') {
              this.uploadingMessage =
                'Could not upload the file: marketAdjustmentCSVFile!'
              document.getElementById('uploadMarketFile').value = null
            } else if (e.message == 'Request failed with status code 400') {
              this.uploadingMessage = 'Please upload a csv file!'
              document.getElementById('uploadMarketFile').value = null
            } else {
              this.uploadingMessage = ''
            }
            this.failure = true
            modal.style.display = 'none'
          })
      } else {
        this.globalMessage = 'choose a csv file'
        this.uploadingMessage = ''
      }
    },

    retrieveyearlist: function () {
      console.log('YEAR LENGTH : ' + JSON.stringify(this.getpurchasedatalist.length))
      collateralprice
        .get('/readyear')
        .then(response => {
          this.yearlist = response.data
          console.log('YEAR : ' + JSON.stringify(this.yearlist))
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    retrievemakelist: function () {
      collateralprice
        .get('/readmake', {
          params: {
            year: this.collateraldata.year
          }
        })
        .then(response => {
          this.makelist = response.data
          console.log('make  : ' + this.make)
          for (var i = 0; i < this.makelist.length; i++) {
            if (this.make.toLowerCase() == this.makelist[i].make.toLowerCase()) {
              console.log('YEAR LIST : ' + this.yearlist[i].make)
              this.collateraldata.make = this.makelist[i].make
              this.retrievemodellist()
              console.log('make LIST : ' + this.makelist[i].make)
            }
          }

          // console.log("MAKE : "+JSON.stringify(this.makelist));
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    retrievemodellist: function () {
      collateralprice
        .get('/readmodel', {
          params: {
            year: this.collateraldata.year,
            make: this.collateraldata.make
          }
        })
        .then(response => {
          this.modellist = response.data
          for (var i = 0; i < this.modellist.length; i++) {
            if (this.model.toLowerCase() == this.modellist[i].model.toLowerCase()) {
              this.collateraldata.model = this.modellist[i].model
            }
          }
          console.log(this.modellist)
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrievestylelist: function () {
      console.log('STYLE LIST')
      collateralprice
        .get('/readstyle', {
          params: {
            year: this.collateraldata.year,
            make: this.collateraldata.make,
            model: this.collateraldata.model
          }
        })
        .then(response => {
          this.stylelist = response.data
          for (var i = 0; i < this.stylelist.length; i++) {
            if (this.trim.toLowerCase() == this.stylelist[i].trimStyle.toLowerCase()) {
              this.collateraldata.trimstyle = this.modellist[i].trimStyle
            }
          }

          console.log(this.stylelist)
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    resetdata () {
      this.saved = false
      this.collateraldata = this.initializedata()
      this.message = ''
      this.errors.clear()
      this.$validator.reset()
      this.checked = true
      this.getpurchasedatalist.response = null
      this.getpurchasedatalist.status = null
      this.uploadingMessage = ''
    },
    getpurchasedetails () {
      if (this.collateraldata.year == '' || this.collateraldata.make == '' || this.collateraldata.model == '') {
        this.msgcolor.color = 'red'
        this.uploadingMessage = 'Please enter VIN or vehicle Info to continue'
      }
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          if (this.checked == false) {
            this.collateraldata.marketAdjustmentChoice = 'N'
            this.checked = false
            console.log('VIN NUMBER  : ' + this.collateraldata.marketAdjustmentChoice)
          } else if (this.checked == true) {
            this.collateraldata.marketAdjustmentChoice = 'Y'
            this.checked = true
          }

          let newdata = {
            request: {
              make: this.collateraldata.make,
              year: this.collateraldata.year,
              model: this.collateraldata.model,
              loanDuration: this.collateraldata.loanduration,
              trim: this.collateraldata.trimstyle,
              msrp: this.collateraldata.PurchasePrice,
              vin: this.collateraldata.vin,
              marketAdjustmentChoice: this.collateraldata.marketAdjustmentChoice,
              adjustmentValue: this.collateraldata.adjustmentValue
            }
          }

          collateralprice
            .post('/getPuchasePriceDetails', newdata)
            .then(response => {
              this.getpurchasedatalist = response.data
              this.collateraldata.adjustmentMade = this.getpurchasedatalist.status.adjustmentMade
              this.collateraldata.adjustmentValue = this.getpurchasedatalist.status.adjustmentValue
              console.log('COLLETERAL RRRESPONSE : ' + JSON.stringify(this.getpurchasedatalist))
              console.log('COLLETERAL RRRESPONSE AVL : ' + JSON.stringify(this.getpurchasedatalist.status.MonthsAvailable))
              console.log('COLLETERAL RRRESPONSE REQ : ' + JSON.stringify(this.getpurchasedatalist.status.MonthsRequired))
              if (parseInt(this.getpurchasedatalist.status.MonthsAvailable) < parseInt(this.getpurchasedatalist.status.MonthsRequired)) {
                this.monthMessage = 'No sufficient month curve values'
              } else {
                this.monthMessage = ''
              }

              if (
                Object.keys(this.getpurchasedatalist.response)[Object.keys(this.getpurchasedatalist.response).length - 1] != 'inception' &&
  Object.keys(this.getpurchasedatalist.response)[Object.keys(this.getpurchasedatalist.response).length - 1] != 'month12' &&
    Object.keys(this.getpurchasedatalist.response)[Object.keys(this.getpurchasedatalist.response).length - 1] != 'month24' &&
      Object.keys(this.getpurchasedatalist.response)[Object.keys(this.getpurchasedatalist.response).length - 1] != 'month36' &&
        Object.keys(this.getpurchasedatalist.response)[Object.keys(this.getpurchasedatalist.response).length - 1] != 'month48' &&
          Object.keys(this.getpurchasedatalist.response)[Object.keys(this.getpurchasedatalist.response).length - 1] != 'month60' &&
            Object.keys(this.getpurchasedatalist.response)[Object.keys(this.getpurchasedatalist.response).length - 1] != 'month72'
              ) {
                this.monthN = Object.values(this.getpurchasedatalist.response)[Object.keys(this.getpurchasedatalist.response).length - 1]
              } else {
                this.monthN = ''
              }

              this.saved = true
              this.responsemessage = this.getpurchasedatalist.response
              // this.collateraldata = this.initializedata();
            })
        }
      })
    },

    fetchdata () {
      this.retrieveyearlist()
      this.getGlobalToExport()
      this.getMarketToExport()
      this.getFactorToExport()
    },
    getFactorToExport () {
      collateralprice
        .get('/factorValuesExport').then(response => {
          this.factorData = response.data
        })
      this.factorexport = 'FactorValues_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
    },
    getGlobalToExport () {
      collateralprice
        .get('/globalAdjustmentsExport').then(response => {
          this.globalData = response.data
        })
      this.globalexport = 'GlobalAdjustments_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
    },
    getMarketToExport () {
      console.log('test Market Export')
      collateralprice
        .get('/marketAdjustmentsExport').then(response => {
          this.marketData = response.data
        })
      this.marketexport = 'MarketAdjustments_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  }
}
</script>
<style scoped>
</style>
